import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import FearRoom from "../components/FearRoom";
import { fears } from "../data/fears";

function FearDetail() {
  const { slug } = useParams();
  const fear = fears.find((item) => item.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [slug]);

  if (!fear) {
    return (
      <section className="mx-auto flex min-h-[70vh] w-full max-w-3xl flex-col items-center justify-center px-5 text-center">
        <p className="text-xs uppercase tracking-[0.32em] text-museum-gold">Closed wing</p>
        <h1 className="mt-5 font-display text-5xl text-museum-bone">This room does not exist.</h1>
        <Link to="/#gallery" className="mt-8 rounded-full border border-museum-bone/20 px-6 py-3 text-sm font-semibold text-museum-bone transition hover:border-museum-gold/60 hover:text-museum-gold">
          Return to Gallery
        </Link>
      </section>
    );
  }

  return <FearRoom fear={fear} />;
}

export default FearDetail;
